import { combineReducers } from 'redux';

import authUser from './authUser';
import user from './user';
import query from './query';
import results from './results';

export default combineReducers({
  query,
  results,
  authUser,
  user
})



// WEBPACK FOOTER //
// ./src/reducers/index.js